<template>
    <div class="summary-item">
        <div>
          <p style="font-weight: bold; margin-top: 5px; margin-bottom: 5px;">{{gaugeTitle}}</p>
          <div class="row-money-value">
            <span class="row-label">Original</span>
            <span class="money-value actual-pad">{{originalValueFormatted}}</span>
          </div>
          <hr/>
          <div class="row-money-value actual-pad">
            <span class="row-label">Actual</span>
            <span class="money-value">{{actualValueFormatted}}</span>
          </div>
          <button disabled class="left-btn" :class="leftGaugeBad ? 'bad' : 'good'" v-if="leftGaugeValue!=null">{{leftGaugeValueFormatted}}</button>
          <button disabled class="right-btn" :class="rightGaugeBad ? 'bad' : 'good'" v-if="rightGaugeValue!=null">{{rightGaugeValueFormatted}}</button>
        </div>
    </div>
    </template>
    
    <script>
    export default {
      props: {
        gaugeTitle: {
          type: String
        },
        leftGaugeValue: {
          type: Number
        },
        leftGaugeValueFormat: {
          type: String
        },
        rightGaugeValue: {
          type: Number
        },
        rightGaugeValueFormat: {
          type: String
        },
        actualValue: {
        },
        actualValueFormat: {
          type: String
        },
        originalValue: {
        },
        originalValueFormat: {
          type: String
        },
        leftGaugeBad: {
          type: Boolean
        },
        rightGaugeBad: {
          type: Boolean
        },
      },
      components: {},
      computed: {
        originalValueFormatted(){
          if(this.originalValueFormat == "percent"){
            return Intl.NumberFormat("en-AU", {style: "percent", minimumFractionDigits: 2}).format(this.originalValue);
          } else if (this.originalValueFormat == "currency") {
            return Intl.NumberFormat("en-AU", {style: "currency", currency: "AUD"}).format(this.originalValue);
          }
          return this.originalValue;
        },
        actualValueFormatted(){
          if(this.actualValueFormat == "percent"){
            return Intl.NumberFormat("en-AU", {style: "percent", minimumFractionDigits: 2}).format(this.actualValue);
          } else if (this.actualValueFormat == "currency") {
            return Intl.NumberFormat("en-AU", {style: "currency", currency: "AUD"}).format(this.actualValue);
          }
          return this.actualValue;
        },
        leftGaugeValueFormatted(){
          if(this.leftGaugeValue == null) return;
          if(this.leftGaugeValueFormat == "percent"){
            return Intl.NumberFormat("en-AU", {style: "percent", minimumFractionDigits: 2}).format(this.leftGaugeValue);
          } else if (this.leftGaugeValueFormat == "currency") {
            return Intl.NumberFormat("en-AU", {style: "currency", currency: "AUD"}).format(this.leftGaugeValue);
          }
          return this.leftGaugeValue;
        },
        rightGaugeValueFormatted(){
          if(this.rightGaugeValueFormat == "percent"){
            return Intl.NumberFormat("en-AU", {style: "percent", minimumFractionDigits: 2}).format(this.rightGaugeValue);
          } else if (this.rightGaugeValueFormat == "currency") {
            return Intl.NumberFormat("en-AU", {style: "currency", currency: "AUD"}).format(this.rightGaugeValue);
          }
          return this.rightGaugeValue;
        }
      },
    }
    </script>
    
    <style>
        .summary-item {
        display: inline-block;
        background-color: white;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 10px;
        padding-top: 0px;
        margin: 10px;
        width: 25%;
        max-width: 500px;
        min-width: 285px;
        border-radius: 5px;
        text-align: bottom;
        font-size: 16px;
        }
    
    
      .left-btn {
        border: none;
        padding: 10px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        border-radius: 5px;
      }
    
      .bad {
        background-color: #e8384f;
        color: white;
      }
    
      .good {
        background-color: #62d26f;
        color: black;
      }
    
      .right-btn {
        float: right;
        border: none;
        padding: 10px 32px;
        text-align: center;
        text-decoration: none;
        font-size: 16px;
        font-weight: bold;
        border-radius: 5px;
      }
    
      .row-money-value {
        text-align: right;
      }
      .actual-pad {
        padding-bottom: 5px;
      }
      .row-label{
        text-align: left;
        float: left;
      }

      .money-value {
        font-weight: bold;

        font-size: 24px;
        position: center;
        padding-left: 30px;
      }
    </style>
    